.contactB2CForm {
  --primary-color: #154dd1;
  --primary-border-color: #154dd1;
  --primary-text-color: #fff;
  --primary-hover-color: #193f99;
  --primary-hover-border-color: #193f99;
  --primary-hover-text-color: #fff;
  --primary-background-input-field-color: #e6eff6;
  --primary-placeholder-color: #9fa9bc;
  --primary-border-focus-color: #075da7;
  --primary-cta-color: #e30613;

  --secondary-color: #154dd1;
  --secondary-border-color: #e6eff6;
  --secondary-text-color: #002b4d;
  --secondary-hover-color: #193f99;
  --secondary-hover-border-color: #193f99;
  --secondary-hover-text-color: #fff;

  font-size: 16px;
  padding: 0 32px 40px 32px;
  background-color: var(--primary-text-color);
  border-radius: 8px;
  opacity: 1;
  transition: all 0.2s linear;
}

.action {
  flex: 1 1 50%;
  position: relative;
  font-size: 16px;
  font-weight: 300;
  line-height: 24px;
  font-family: "CornerDisplay", sans-serif;
  color: var(--form-text-color);
}

.contactB2CTitle {
  text-align: left;
  font-size: 30px;
  font-weight: 700;
  line-height: 1.2;
  margin: 32px 0 24px 0;
  color: var(--secondary-text-color);
  text-transform: uppercase;
}

.contactB2CSubTitle {
  color: var(--form-text-info-color);
  font-size: 20px;
  font-weight: 200;
  line-height: 1.27;
  margin: 16px auto 24px;
  text-align: left;
}

.contactB2CForm h3 {
  font-size: 18px;
  font-weight: 500;
  margin: 12px 0 -12px 0;
  line-height: 1.31;
  color: var(--form-text-color);
}

div.customRadio {
  font-family: "Inter", sans-serif;
}

div.customRadio > label {
  padding-left: 48px;
}

div.customRadio label:focus-within {
  border: solid 1px var(--secondary-border-color);
}

div.customFieldRow {
  margin: 0 -6px;
  display: flex;
  flex-direction: column;
}

div.customPhoneInput > div,
div.customPhoneInput > div > input[type="text"] {
  width: 80px !important;
}

div.customPhoneInput,
div.customInput {
  border: none;
  border-radius: 8px;
  background-color: var(--primary-background-input-field-color);
}

div.customPhoneInput > div > div > div > div,
div.customInput > div > div > div {
  font-family: "Inter", sans-serif;
}

div.customPhoneInput > input::placeholder,
div.customInput > input::placeholder {
  color: var(--primary-placeholder-color);
}

/* div.customPhoneInput > input:focus::placeholder,
div.customInput > input:focus::placeholder {
  opacity: 0;
} */

div.customPhoneInput:focus-within,
div.customInput:focus-within {
  border: solid 2px var(--secondary-border-color);
  background-color: var(--primary-hover-text-color);
}

div.customPhoneInput > div > input,
div.customInput > input,
div.customInput > input[type="text"] {
  color: var(--secondary-text-color);
}

label.customLabel {
  display: block;
  margin-bottom: 8px;
  font-weight: 700;
  color: var(--secondary-text-color);
  font-size: 12px;
  font-family: "CornerDisplayBolder", sans-serif;
  text-transform: uppercase;
}

label.customLabel:has(+ .customPhoneInput:focus-within),
label.customLabel:has(+ .customInput:focus-within) {
  color: var(--primary-border-focus-color);
}

div.customPhoneInput > div > i,
div.customInput > i {
  display: none;
  color: var(--form-arrow-color) !important;
  font-size: 16px !important;
}

.contactB2CForm textarea {
  resize: vertical;
}

.cta {
  margin-top: 12px;
  text-align: left;
  width: 119px;
}

.disclaimer {
  font-size: 14px;
  line-height: 1.33;
}

div.disclaimerRow {
  flex-direction: row;
}

.disclaimer i {
  margin-left: 0.5rem;
  padding-top: 1rem;
  cursor: pointer;
}

.expContent {
  font-size: 12px;
  line-height: 1.33;
  padding-top: 10px;
}

.expContent ul {
  margin-top: 8px;
  list-style: outside;
}

.expContent li {
  margin-left: 16px;
}

.contactB2CForm button {
  text-transform: uppercase;
  min-width: 150px;
  font-size: 18px;
  font-weight: 500;
  line-height: 1.3;
  padding: 6px 16px;
  font-family: "CornerDisplay", sans-serif;
  border: solid 2px var(--primary-cta-color) !important;
  background-color: var(--primary-cta-color) !important;
  border-radius: 8px;
}

.contactB2CForm .cta button:hover {
  border: none !important;
}

.errorSubmit {
  color: var(--form-text-error-color);
  display: block;
  margin-top: 20px;
}

.disclaimerInfo {
  line-height: 1.56;
  padding: 24px 24px 16px;
  margin-top: 12px;
  background-color: var(--form-background-info-color);
  border-radius: 4px;
  font-family: "Inter", sans-serif;
}

.disclaimerInfo > ul {
  margin: 16px 0 16px 1px;
  list-style: none;
}

.disclaimerInfo li:not(:last-child) {
  margin-bottom: 16px;
}

.disclaimerInfo li {
  position: relative;
  padding-left: 18px;
}

.disclaimerInfo li::before {
  content: "";
  position: absolute;
  top: 11px;
  left: 0;
  width: 6px;
  height: 6px;
  background-color: var(--form-text-title-color);
  border-radius: 3px;
}

div.containerError {
  text-align: center;
}

@media screen and (min-width: 769px) {
  .contactB2CTitle {
    justify-content: center;
    font-size: 52px;
  }
}

@media screen and (min-width: 993px) {
  .contactB2CTitle {
    font-size: 64px;
  }

  .contactB2CSubTitle {
    font-size: 24px;
  }

  .disclaimerInfo {
    font-size: 18px;
  }
}

@media screen and (min-width: 1280px) {
  .action {
    flex: 1 0 600px;
  }

  div.customFieldRow {
    flex-direction: row;
    flex-wrap: wrap;
  }
}
